import React from 'react';

import { SectionMessageAction } from '@atlaskit/section-message';

import SectionMessage from '@qality/common-components/src/atoms/atlaskit/SectionMessage';

import { SectionMessageContainer } from './CreateIssueTypeExplanationBanner.styled';

interface CreateIssueTypeExplanationBannerProps {
  nameSuffix: string;
}

export const CreateIssueTypeExplanationBanner: React.FC<CreateIssueTypeExplanationBannerProps> =
  ({ nameSuffix }: CreateIssueTypeExplanationBannerProps) => {
    return (
      <SectionMessageContainer>
        <SectionMessage
          title='Create new Issue type to start exploring QAlity Plus'
          appearance='information'
          actions={[
            <SectionMessageAction
              key='get-more-details'
              href='#'
              onClick={() => window.open(plugin.quickStartUrl, '_blank')}
            >
              Get more details
            </SectionMessageAction>,
          ]}
        >
          <span>
            QAlity {nameSuffix} stores the data in Jira issues. To start using
            QAlity {nameSuffix}, Project’s Administrator needs to add QAlity
            Test issue type.
          </span>
        </SectionMessage>
      </SectionMessageContainer>
    );
  };
